import { sendBackgroundMessage } from '$tablet-app/src/app/chat/functions';
import { intent_labels } from '$tablet-app/src/app/chat/intent_labels';
import TodayBadge from '$tablet-app/src/app/components/TodayBadge';
import { DeveloperScreenInfo } from '$tablet-app/src/app/developer/components/DeveloperScreenInfo/DeveloperScreenInfo';
import { CalendarItemType } from '$tablet-app/src/app/models';
import { MainDrawerScreenProps } from '$tablet-app/src/app/navigation/MainDrawerNavigator';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import useCurrentDay from '$tablet-app/src/app/utils/useCurrentDay';
import { useIsFocused } from '@react-navigation/native';
import { isSameDay } from 'date-fns';
import React, { useEffect } from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import CalendarScreenHeader from '../CalendarScreenHeader';
import CalendarScreenMonthView from '../CalendarScreenMonthView';
import CalendarScreenPortraitView from '../CalendarScreenPortraitView';
import { CalendarWeekView } from '../CalendarWeekView/CalendarWeekView';

/** The calendar screen handles the state, navigation and modals used in the calendar screens */
const CalendarScreen = (props: MainDrawerScreenProps<'Calendar'>) => {
  const {
    navigation: { navigate },
  } = props;

  const current_day_string = useCurrentDay();

  const is_focused = useIsFocused();

  const active_date_string = useStateStore(
    (state) => state.calendar.active_date_string
  );

  const display_mode = useStateStore((state) => state.calendar.display_mode);

  const onSelectDate = useStateStore((state) => state.calendar.setActiveDate);

  const onPressCreate = (params?: { start?: string }) => {
    const date = params?.start ? new Date(params?.start) : new Date();
    date.setHours(new Date().getHours(), new Date().getMinutes());

    navigate('CreateCalendarItem', {
      type: CalendarItemType.Event,
      defaults: { start: date.toISOString() },
    });
  };

  const onPressItem = (data: { id: string; type: CalendarItemType }) => {
    navigate('CalendarItemDetails', { id: data.id, type: data.type });
  };

  // TODO: (MS) Is this even used?
  useEffect(() => {
    const current_day = new Date(current_day_string);
    const active_date = new Date(active_date_string);

    if (!isSameDay(current_day, active_date)) {
      onSelectDate(current_day.toISOString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_day_string, onSelectDate]);

  useEffect(() => {
    if (is_focused) {
      sendBackgroundMessage(intent_labels.open_calendar_screen);
    }
  }, [is_focused]);

  const handleTodayPress = () => {
    onSelectDate(new Date().toISOString());
  };

  const { width } = useWindowDimensions();
  const isSmall = width < 1000;

  /** The UI for the calendar screen */
  return (
    <>
      <Container>
        <CalendarScreenHeader
          rightContent={
            isSmall ? <TodayBadge onPress={handleTodayPress} /> : undefined
          }
        />

        <Body>
          {isSmall ? (
            <CalendarScreenPortraitView
              onPressItem={onPressItem}
              onPressCreateItem={onPressCreate}
            />
          ) : display_mode === 'week' ? (
            <CalendarWeekView onPressItem={onPressItem} />
          ) : (
            <CalendarScreenMonthView
              onPressItem={onPressItem}
              onPressCreateItem={onPressCreate}
            />
          )}
        </Body>
      </Container>
      <DeveloperScreenInfo />
    </>
  );
};

const Container = styled.View`
  flex: 1;
`;

const Body = styled.View`
  flex: 1;
  justify-content: center;
`;

export default CalendarScreen;
